// src/components/Footer.jsx
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { APP_INFO } from "../constants/AppInfo";
import storage from "../utils/storage";
import LoginModal from "../pages/Login/LoginModal";

const Footer = () => {
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false); // Add logged in state
  const [token, setToken] = React.useState("");

  useEffect(() => {
    const token = storage.getAccessToken();
    setToken(token);
  }, []);

  const prepaidCardUrl = `https://prepaid-card.formaxpay.com/?token=${token}&source=rechargepos`;
  const applyCreditCardUrl = `https://products.formaxpay.com/?token=${token}&source=rechargepos`;

  const handleNavigation = (path) => {
    if (!token) {
      setShowModal(true);
      return;
    }
    navigate(path);
  };

  return (
    <>
      <footer id="footer" className="bg-white pt-5 pb-4 mt-0">
        <div className="container">
          <div className="row g-4">
            <div className="col-sm-6 col-md">
              <h4 className="text-3 fw-400 mb-3">Recharge</h4>
              <ul className="nav flex-column">
                <li className="nav-item">
                  {" "}
                  <a className="nav-link" href="/mobile-recharge">
                    Mobile Recharge
                  </a>
                </li>
                <li className="nav-item">
                  {" "}
                  <a className="nav-link" href="/dth-recharge">
                    DTH Recharge
                  </a>
                </li>
                <li className="nav-item">
                  {" "}
                  <a className="nav-link" href="/google-play-redeem-code">
                    Google Play Redeem Code
                  </a>
                </li>
              </ul>
            </div>

            {/* <div className="col-sm-6 col-md">
              <h4 className="text-3 fw-400 mb-3">Bill Payments</h4>
              <ul className="nav flex-column">
                <li className="nav-item">
                  {" "}
                  <a className="nav-link" href="/bill-payment/Fastag">
                    FasTag Recharge
                  </a>
                </li>
                <li className="nav-item">
                  {" "}
                  <a className="nav-link" href="/bill-payment/Electricity">
                    Electricity Bill Payment
                  </a>
                </li>
                <li className="nav-item">
                  {" "}
                  <a className="nav-link" href="/bill-payment/Postpaid">
                    Mobile Postpaid Bill Payment
                  </a>
                </li>
                <li className="nav-item">
                  {" "}
                  <a className="nav-link" href="/bill-payment/Landline">
                    Landline Bill Payment
                  </a>
                </li>
                <li className="nav-item">
                  {" "}
                  <a className="nav-link" href="/bill-payment/Broadband">
                    Broadband Bill Payment
                  </a>
                </li>
                <li className="nav-item">
                  {" "}
                  <a className="nav-link" href="/bill-payment/Loan Repayment">
                    Loan Repayment
                  </a>
                </li>
                <li className="nav-item">
                  {" "}
                  <a className="nav-link" href="/bill-payment/LPG Gas">
                    Book Cylinder
                  </a>
                </li>
                 <li className="nav-item">
                  {" "}
                  <a className="nav-link" href="/bill-payment/Insurance">
                    Insurance
                  </a>
                </li> 
                <li className="nav-item">
                  {" "}
                  <a className="nav-link" href="/bill-payment/Water">
                    Water
                  </a>
                </li>
              </ul>
            </div> */}
            {/* <div className="col-sm-6 col-md">
              <h4 className="text-3 fw-400 mb-3">Financial Services</h4>
              <ul className="nav flex-column">
                <li className="nav-item">
                  <a
                    className="nav-link"
                    href={token ? prepaidCardUrl : "#"}
                    onClick={(e) => {
                      if (!token) {
                        e.preventDefault();
                        setShowModal(true);
                      }
                    }}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Prepaid Card
                  </a>
                </li>
                <li className="nav-item">
                  <span
                    className="nav-link"
                    style={{ cursor: "pointer" }}
                    onClick={() => handleNavigation("/insurance")}
                  >
                    Insurance
                  </span>
                </li>
                <li className="nav-item">
                  <span
                    className="nav-link"
                    style={{ cursor: "pointer" }}
                    onClick={() =>
                      handleNavigation("/credit-card-to-bank-transfer")
                    }
                  >
                    Credit Card to Bank Transfer
                  </span>
                </li>
                <li className="nav-item">
                  <a
                    className="nav-link"
                    href={token ? applyCreditCardUrl : "#"}
                    onClick={(e) => {
                      if (!token) {
                        e.preventDefault();
                        setShowModal(true);
                      }
                    }}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Apply Credit Cards
                  </a>
                </li>
              </ul>
            </div> */}

            <div className="col-sm-6 col-md">
              <h4 className="text-3 fw-400 mb-3">Company</h4>
              <ul className="nav flex-column">
                <li className="nav-item">
                  {" "}
                  <a className="nav-link" href="/about-us">
                    About Us
                  </a>
                </li>
                <li className="nav-item">
                  {" "}
                  <a className="nav-link" href="/contact-us">
                    Contact Us
                  </a>
                </li>
                <li className="nav-item">
                  {" "}
                  <a className="nav-link" href="/privacy-policy">
                    Privacy Policy
                  </a>
                </li>
                <li className="nav-item">
                  {" "}
                  <a className="nav-link" href="/terms-and-conditions">
                    Terms &amp; Conditions
                  </a>
                </li>
                <li className="nav-item">
                  {" "}
                  <a className="nav-link" href="/refund-policy">
                    Refund Policy
                  </a>
                </li>
                <li className="nav-item">
                  {" "}
                  <a className="nav-link" href="/grievance-policy">
                    Grievance Policy
                  </a>
                </li>
                <li className="nav-item">
                  {" "}
                  <a className="nav-link" href="/faq">
                    FAQ
                  </a>
                </li>
                <li className="nav-item">
                  {" "}
                  <a className="nav-link" href="/support">
                    Support
                  </a>
                </li>
              </ul>
            </div>

            <div className="col-sm-6 col-md">
              <h4 className="text-3 fw-400 mb-3">Help Center</h4>
              <ul className="nav flex-column">
                <li className="nav-item">
                  {" "}
                  <a className="nav-link" href="/support">
                    Support
                  </a>
                </li>
                <li className="nav-item">
                  {" "}
                  <a className="nav-link" href="/faq">
                    FAQ
                  </a>
                </li>
              </ul>
            </div>

            {/* <div className="col-12 col-lg-3">
              <h4 className="text-3 fw-400 mb-3">Download Recharge POS App</h4>
              <div className="d-flex align-items-center mb-3">
                <a
                  href={APP_INFO.appDownloadUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src="/assets/images/qr-code.png"
                    alt="QR Code to download app"
                    style={{
                      width: "180px",
                      height: "180px",
                      //  marginRight: "15px",
                    }}
                  />

                  <img
                    src="/assets/images/playstore-badge.png"
                    alt="Get it on Google Play"
                    style={{ height: "50px" }}
                  />
                </a>
              </div>

              <h4 className="text-3 fw-400 mb-3">Follow us on</h4>
              <ul className="social-icons social-icons-sm social-icons-colored">
                <li className="social-icons-facebook">
                  <a
                    data-bs-toggle="tooltip"
                    href={APP_INFO.facebookUrl}
                    target="_blank"
                    title="Facebook"
                  >
                    <i className="fab fa-facebook-f" />
                  </a>
                </li>
                <li className="social-icons-whatsapp">
                  <a
                    data-bs-toggle="tooltip"
                    href={APP_INFO.whatsappUrl}
                    target="_blank"
                    title="whatsapp"
                    style={{ backgroundColor: "#128c7e" }}
                  >
                    <i className="fab fa-whatsapp" />
                  </a>
                </li>

                <li className="social-icons-instagram">
                  <a
                    data-bs-toggle="tooltip"
                    href={APP_INFO.instagramUrl}
                    target="_blank"
                    title="Instagram"
                  >
                    <i className="fab fa-instagram" />
                  </a>
                </li>
                <li className="social-icons-youtube">
                  <a
                    data-bs-toggle="tooltip"
                    href={APP_INFO.youtubeUrl}
                    target="_blank"
                    title="Youtube"
                  >
                    <i className="fab fa-youtube" />
                  </a>
                </li>
                <li className="social-icons-telegram">
                  <a
                    data-bs-toggle="tooltip"
                    href={APP_INFO.telegramUrl}
                    target="_blank"
                    title="Telegram"
                  >
                    <i className="fab fa-telegram" />
                  </a>
                </li>
              </ul>
            </div> */}
          </div>
        </div>
        <div className="footer-copyright pt-4 mt-4">
          <div className="container">
            <div className="row">
              <div className="col-lg d-flex align-items-center">
                <p className="copyright-text text-center text-lg-start mt-0 mb-2 mb-lg-0">
                  Copyright © {new Date().getFullYear()}{" "}
                  <a href="/">{APP_INFO.companyName}</a>. All Rights Reserved.
                </p>
              </div>
              <div className="col-lg d-flex align-items-center align-items-lg-end flex-column">
                <ul className="payments-types">
                  <li>
                    <a>
                      {" "}
                      <img
                        data-bs-toggle="tooltip"
                        src="/assets/images/payment/upi.png"
                        alt="upi"
                        title="UPI"
                      />
                    </a>
                  </li>
                  <li>
                    <a>
                      {" "}
                      <img
                        data-bs-toggle="tooltip"
                        src="/assets/images/payment/rupay.png"
                        alt="rupay"
                        title="Rupay"
                      />
                    </a>
                  </li>
                  <li>
                    <a>
                      {" "}
                      <img
                        data-bs-toggle="tooltip"
                        src="/assets/images/payment/visa.png"
                        alt="visa"
                        title="Visa"
                      />
                    </a>
                  </li>

                  <li>
                    <a>
                      {" "}
                      <img
                        data-bs-toggle="tooltip"
                        src="/assets/images/payment/american.png"
                        alt="american express"
                        title="American Express"
                      />
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </footer>
      {/* Footer end */}

      <LoginModal
        show={showModal}
        onHide={() => setShowModal(false)}
        onLoginSuccess={() => setIsLoggedIn(true)} // Add login success handler
      />
    </>
  );
};

export default Footer;
